import React, { useEffect } from 'react';
import { MaskInput } from 'maska';

interface PhoneNumberProps {
    placeholder?: string;
    value: string;
    setValue: (value: string) => void;
    label: string;
    hideLabel?: boolean;
    inputClassName?: string;
}

export default function PhoneNumber({ placeholder, value, setValue, label, hideLabel = false, inputClassName }: PhoneNumberProps) {
    const handlePhoneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
    };

    useEffect(() => {
        new MaskInput('.maska');
    }, []);

    return (
        <div className="form-control">
            {!hideLabel && (
                <label className="label" htmlFor="phone">
                    <span className="label-text">{label}</span>
                </label>
            )}
            <input
                id="phone"
                className={`maska ${inputClassName || 'input input-bordered w-full max-w-96'}`}
                aria-label={hideLabel ? label : undefined}
                type="tel"
                placeholder={placeholder}
                data-maska="['+55 (##) ####-####', '+55 (##) # ####-####']"
                value={value}
                onChange={handlePhoneChange}
                onBlur={handlePhoneChange}
            />
        </div>
    );
}
